<template>
  <div>
    <el-row :gutter="24" class="content-bottom-padded search-form-row">
      <el-col :xs="24" :sm="12" :md="3">
        <el-select v-model="params.memo" placeholder="明细类型" size="mini" @change="searchData" class="search-form-item">
          <el-option v-for="item in memoOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="12" :md="4">
        <el-input
          placeholder="会员ID"
          v-model="params.user_id"
          clearable
          size="mini"
          @keyup.enter.native="searchData"
          @clear="searchData"
          class="search-form-item"
        >
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <el-col :xs="24" :sm="24" :md="6">
        <el-date-picker
          v-model="created"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="dateChange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="mini"
          class="search-form-item search-form-date"
        >
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" class="search-form-actions">
        <el-button type="primary" size="mini" @click="searchData">搜索</el-button>
        <el-button size="mini" @click="exportData" :loading="exportLoading">导出</el-button>
        <el-button size="mini" type="warning" @click="openStaffExportDialog" :loading="staffExportLoading">员工佣金明细导出</el-button>
      </el-col>
    </el-row>

    <el-table :data="dataList" :height="wheight - 190" v-loading="loading">
      <el-table-column prop="user_id" label="会员ID" width="100" />
      <el-table-column prop="order_id" label="订单号" width="180" />
      <el-table-column prop="import_money" label="存入金额" width="130" />
      <el-table-column prop="explode_money" label="支出金额" width="130" />
      <el-table-column prop="member_advance" label="当前余额" width="130" />
      <el-table-column prop="message" label="管理备注" width="160" />
      <el-table-column prop="memo" label="业务摘要" width="160" />
      <el-table-column prop="mtime_date" label="交易时间" width="160" />
    </el-table>

    <div v-if="total_count > params.pagesize" class="content-center content-top-padded">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50]"
        :total="total_count"
        :page-size="params.pagesize"
      >
      </el-pagination>
    </div>

    <el-dialog title="员工佣金明细导出" :visible.sync="staffExportDialogVisible" width="420px" :close-on-click-modal="false">
      <div style="margin-bottom: 12px; color: #909399; font-size: 13px;">
        请选择员工提现计入工资的月份，导出对应批次佣金明细
      </div>
      <el-date-picker
        v-model="staffExportMonth"
        type="month"
        placeholder="选择月份"
        format="yyyy年MM月"
        value-format="yyyy-MM"
        size="small"
        style="width: 100%;"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="staffExportDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="staffExportLoading" @click="exportStaffCommissionDetail">确认导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getPlatformRewardList, platformRewardListExport, memberAdvanceDetailExport } from '../../../api/sharer'

export default {
  name: 'PlatformRewardList',
  data () {
    return {
      loading: false,
      exportLoading: false,
      staffExportLoading: false,
      staffExportDialogVisible: false,
      staffExportMonth: '',
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
        user_id: '',
        memo: '全部',
        time_start_begin: '',
        time_start_end: ''
      },
      memoOptions: [
        { label: '全部', value: '全部' },
        { label: '平台奖励', value: '平台奖励' },
        { label: '申请提现', value: '申请提现' },
        { label: '订单收益', value: '订单收益' }
      ],
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dataList: []
    }
  },
  computed: {
    ...mapGetters(['wheight'])
  },
  methods: {
    getDataList () {
      this.loading = true
      getPlatformRewardList(this.params)
        .then(response => {
          this.dataList = response.data.data.list || []
          this.total_count = Number(response.data.data.total_count || 0)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取平台奖励资金明细失败'
          })
        })
    },
    searchData () {
      this.params.page = 1
      this.getDataList()
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      this.getDataList()
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    handleCurrentChange (pageNum) {
      this.params.page = pageNum
      this.getDataList()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.pagesize = pageSize
      this.getDataList()
    },
    exportData () {
      this.exportLoading = true
      const params = {
        user_id: this.params.user_id,
        memo: this.params.memo,
        time_start_begin: this.params.time_start_begin,
        time_start_end: this.params.time_start_end
      }
      platformRewardListExport(params)
        .then(response => {
          this.exportLoading = false
          const res = response.data || {}
          console.log(res)
          if (res.data.status) {
            this.$message.success(res.msg || '已加入执行队列，请在设置-导出列表-优选资金明细中下载')
          } else {
            this.$message.error(res.msg || '导出失败，请重试')
          }
        })
        .catch(() => {
          this.exportLoading = false
          this.$message.error('导出失败，请重试')
        })
    },
    openStaffExportDialog () {
      if (!this.staffExportMonth) {
        const now = new Date()
        const y = now.getFullYear()
        const m = String(now.getMonth() + 1).padStart(2, '0')
        this.staffExportMonth = `${y}-${m}`
      }
      this.staffExportDialogVisible = true
    },
    exportStaffCommissionDetail () {
      if (!this.staffExportMonth) {
        this.$message.warning('请选择导出月份')
        return
      }
      this.staffExportLoading = true
      memberAdvanceDetailExport({ year_month: this.staffExportMonth })
        .then(response => {
          this.staffExportLoading = false
          const res = response.data || {}
          if (res.data && res.data.status) {
            this.staffExportDialogVisible = false
            this.$message.success(res.data.msg || res.msg || '已加入执行队列，请在设置-导出列表-员工佣金明细中下载')
          } else {
            this.$message.error((res.data && res.data.msg) || res.msg || '导出失败，请重试')
          }
        })
        .catch((err) => {
          this.staffExportLoading = false
          const msg = (err && err.response && err.response.data && err.response.data.message) || '导出失败，请重试'
          this.$message.error(msg)
        })
    }
  },
  mounted () {
    this.getDataList()
  }
}
</script>

<style scoped lang="scss">
.content-bottom-padded {
  margin-bottom: 20px;
}

.search-form-row {
  .search-form-item {
    width: 100%;
    max-width: 100%;
  }
  .search-form-date {
    min-width: 0; /* 允许在弹性布局下正确收缩 */
  }
  .search-form-actions {
    margin-bottom: 8px;
    @media (min-width: 992px) {
      margin-bottom: 0;
    }
  }
  /* 小屏时每项下方留间距，避免堆叠时贴在一起 */
  @media (max-width: 991px) {
    .el-col {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// platform_reward_list.vue?129d7838